<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Categoria
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: 80px;width: auto;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Categorias
    v-flex(xs12)
      v-card(flat='')
        v-flex(xs12)
          div(style="margin-top:20px")
            v-flex(xs12)
              v-layout(wrap)
                v-flex(xs6)
                  v-text-field(v-model='search2', append-icon='search', label='Buscar' style='width:100%;')
          v-layout(align-start='', justify-start='', row='', fill-height='')
            v-flex(xs12 style='margin-top: 5px;')
              v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
                  v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                      span.white--text Lista de Categorias
              v-data-table.elevation-1(:headers='headers', :items="categoria", :search='search2', style="margin-top: 5px;")
                template(slot='items', slot-scope='props')
                  td {{ props.item.nombre }}
                  td {{ props.item.estatus }}
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
import draggable from "vuedraggable";
export default {
  name: "mCategoria",
  components: {
    draggable
  },
  data: () => ({
    search2: "",
    categoria: [],
    ruta: server + ":" + port,
    headers: [
      { text: "Nombre", value: "nombre" },
      { text: "Estatus", value: "estatus" }
    ],
    cre: "",
    mod: "",
    elm: ""
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.webamairca.permisos.length; i++) {
        if (this.$store.state.webamairca.permisos[i].ruta === "Categoria") {
          for (
            let j = 0;
            j < this.$store.state.webamairca.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    initialize() {
      Api.get("categorias").then(res => {
        this.categoria = res.data;
      });
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/categoria.scss";
</style>
